import { lazy } from 'react';
import { authRoles } from 'app/auth';

const Marketing = lazy(() => import('./MarketingPage'));

const MarketingConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'resources',
      element: <Marketing />,
    },
  ],
};

export default MarketingConfig;
